export default __webpack_public_path__ + "static/media/Administrator.1e42da0b.jpg";